// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles__dialog--nS-AH","body":"styles__body--1dRGD","tabs":"styles__tabs--3mNPr","navigationContainer":"styles__navigationContainer--1g1wx","tab":"styles__tab--1WaGc"};